import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "./context/AppContext";
import Home from "./pages/Home";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import BookingFlow from "./pages/BookingFlow";
import Pharmacy from "./pages/Pharmacy";
import Pathology from "./pages/Pathology";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import StaffDashboard from "./pages/StaffDashboard";
import { PaymentSuccess, PaymentFailed } from "./pages/Payment";
import { About, Contact, LegalPage } from "./pages/StaticPages";

function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id BEFORE routing (prevents race conditions)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/book/:service" element={<BookingFlow />} />
      <Route path="/pharmacy" element={<Pharmacy />} />
      <Route path="/pathology" element={<Pathology />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/staff" element={<StaffDashboard />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/failed" element={<PaymentFailed />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/legal/terms" element={<LegalPage kind="terms" />} />
      <Route path="/legal/privacy" element={<LegalPage kind="privacy" />} />
      <Route path="/legal/refund" element={<LegalPage kind="refund" />} />
      <Route path="/legal/help" element={<LegalPage kind="help" />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}

function App() {
  return (
    <AppProvider>
      <div className="App">
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <AppRouter />
        </BrowserRouter>
      </div>
    </AppProvider>
  );
}

export default App;
